import React from 'react'
import { AgTechButton, AgTechButtonProps, AgTechClickEventHandler } from '@agtech/web/components/Buttons/AgTechButtons';
import AgTechFormBody from '@agtech/web/components/Forms/Layout/AgTechFormBody';
import { AgTechFormRow } from '@agtech/web/components/Forms/Layout/AgTechFormRow';
import AgTechFormDialog from '@agtech/web/components/Portals/Dialogs/AgTechFormDialog';
import { useBidderDataChangeContactAction } from '@sales/data/bidders/BidderDataActions';
import { useBidderDataGetSaleBidderDataQuery } from '@sales/data/bidders/BidderDataQueries';
import { AgTechContact } from '@agtech/data/contacts/ContactData';
import ContactSelectionControl from '@agtech/web/integrations/contacts/components/selections/ContactSelectionControl';

export type BidderChangeContactDialogProps = {
    bidderId: number,
    contactId?: number
}

type BidderChangeContactFormEntity = {
    contact?: AgTechContact
}

const BidderChangeContactDialog = (props: BidderChangeContactDialogProps) => {
    const dialogQuery = useBidderDataGetSaleBidderDataQuery();
    const dialogAction = useBidderDataChangeContactAction();

    return (
        <AgTechFormDialog
            width={350}
            dialogData={{
                query: dialogQuery,
                getDialogData: bidderData => ({
                    contact: props.contactId ? bidderData.contacts[props.contactId] : undefined
                }),
                getDialogContext: bidderData => ({
                    bidders: Object.values(bidderData.bidders)
                })
            }}
            dialogAction={{
                action: dialogAction,
                getActionData: (d) => ({
                    bidderId: props.bidderId,
                    contactId: d.contact?.id ?? 0
                })
            }}
            structure={() => ({
                header: 'Change Contact',
                submitButtonText: 'Change Contact',
            })}
        >
            {(formContext) => (
                <AgTechFormBody>
                    <AgTechFormRow>
                        <ContactSelectionControl
                            formEntity={formContext.entity}
                            control={{ caption: 'Contact', isRequired: true, width: 100 }}
                            contacts={{
                                getSelectedContactId: ent => ent.contact?.id,
                                onContactSelected: async (ent, val) => ({
                                    ...ent,
                                    contact: val ? { ...val } : undefined
                                }),
                                filterContacts: cnt => {
                                    const existingBidder = formContext.context.bidders.find(b => b.contact?.id === cnt.id);
                                    return !existingBidder || existingBidder.id === props.bidderId;
                                }
                            }}
                        />
                    </AgTechFormRow>
                </AgTechFormBody>
            )}
        </AgTechFormDialog>
    )
}

BidderChangeContactDialog.Open = (e: AgTechClickEventHandler, props: BidderChangeContactDialogProps) => {
    e.dialogs.openDialog({
        dialog: () => <BidderChangeContactDialog {...props} />
    });
}

BidderChangeContactDialog.Button = (props: AgTechButtonProps & BidderChangeContactDialogProps) => {
    return (
        <AgTechButton
            text='Change Contact'
            icon='fas fa-refresh'
            {...props}
            action={e => BidderChangeContactDialog.Open(e, props)}
        />
    )
}

export default BidderChangeContactDialog
